enum GeneralConfig {
  APP_VERSION = 22,
  ALLSECTIONS_MAX_MINUTES = 180, // 24 Hours
  AUTH_MAX_MINUTES = 30,
}

export default GeneralConfig;
